<template>
  <div class="storage-chart">
    <b-card title="Storage Usage" class="mb-4">
      <b-row>
        <b-col md="6">
          <b-card-text>
            <div class="storage-stats">
              <p><strong>Total Storage:</strong> {{ data.totalGB }} GB</p>
              <p><strong>Used Storage:</strong> {{ data.usedGB }} GB</p>
              <p><strong>Free Storage:</strong> {{ data.freeGB }} GB</p>
              <p>
                <strong>Usage Percentage:</strong>
                {{ data.usedPercentage }}%
              </p>
            </div>
          </b-card-text>
        </b-col>
        <b-col md="6">
          <b-progress height="10px" class="mb-2">
            <b-progress-bar
              :value="45"
              variant="primary"
              striped
              animated
            ></b-progress-bar>
          </b-progress>
          <small class="text-muted">Development progress: 45%</small>
        </b-col>

        <!-- <b-col md="6">
          <b-card-text>
            <div class="chart-container" :key="chartKey">
              <Doughnut :data="chartData" :options="chartOptions" />
            </div>
          </b-card-text>
        </b-col> -->
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { Doughnut } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

// Register necessary chart.js components
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale
);

export default {
  components: {
    Doughnut,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chartkey: 0,
      chartData: {
        labels: ["Free", "Used"],
        datasets: [],
      },
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          tooltip: {
            enabled: true,
          },
        },
      },
    };
  },
  mounted() {
    this.chartData.datasets = [
      {
        data: [this.storageData.freeGB, this.storageData.usedGB],
        backgroundColor: ["#36a2eb", "#ff6384"],
        hoverBackgroundColor: ["#36a2eb", "#ff6384"],
      },
    ];
    this.chartKey = Math.random(); // Force re-rendering of the chart
  },
};
</script>

<style scoped>
.storage-chart {
  max-width: 800px;
  margin: 0 auto;
}

.storage-stats p {
  margin-bottom: 0.75rem;
}

.chart-container {
  position: relative;
  height: 250px;
}
</style>
